const masterEn = {
    block: require('../../lang/en/master/Block').default,
    brand: require('../../lang/en/master/Brand').default,
    category: require('../../lang/en/master/Category').default,
    city: require('../../lang/en/master/City').default,
    country: require('../../lang/en/master/Country').default,
    department: require('../../lang/en/master/Department').default,
    inventoryUnit: require('../../lang/en/master/InventoryUnit').default,
    item: require('../../lang/en/master/Item').default,
    itemCategory: require('../../lang/en/master/ItemCategory').default,
    location: require('../../lang/en/master/Location').default,
    reason: require('../../lang/en/master/Reason').default,
    shift: require('../../lang/en/master/Shift').default,
    skillMatrix: require('../../lang/en/master/SkillMatrix').default,
    slaAndPriority: require('../../lang/en/master/SlaAndPriority').default,
    spareParts: require('../../lang/en/master/SpareParts').default,
    tools: require('../../lang/en/master/Tools').default,
    staff: require('../../lang/en/master/Staff').default,
    state: require('../../lang/en/master/State').default,
    subLocation: require('../../lang/en/master/SubLocation').default,
    subCategory: require('../../lang/en/master/SubCategory').default,
    taskStatus: require('../../lang/en/master/TaskStatus').default,
    vendor: require('../../lang/en/master/Vendor').default,
    serviceDepartment: require('../../lang/en/master/ServiceDepartment').default,
    master_checklist: require('../../lang/en/master/MasterChecklist').default,

}

export default masterEn;

